import { v4 as uuidv4} from 'uuid';
import Constant from '@/common/constant/Constant';
import Utils, { isAnonymousQAWaitingTicket } from '@/common/utils/utils';
import { checkViewPermissionKnowDetailInList, getTicketById } from '@/service/ticketService';
import { cloneDeep } from 'lodash';
import { getFieldListInForm, getFormById } from '@/service/formManagementService';
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import { API } from 'aws-amplify';
import trI18n from '@/common/utils/trI18n';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { getCorporationById } from '@/service/organizationService';
import {showLoadingMouse, hideLoadingMouse} from '@/common/utils/CustomCursor';
import {  isDisplayIconChat } from '@/component/chatThread/handler/DetailTicketHandler';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

export const unregisterField = (fieldList,unregister) =>{
    for(const field of fieldList){
        unregister(field.fieldId)
    }
}


// get list customer field of selected form
export const getListCustomFiledOfForm = async (formStructure, API, corporationId) => {
    let fieldIdList = [];
    if (!Utils.isEmptyObject(formStructure)) {
        for (const fieldNumber in formStructure) {
            if (formStructure.hasOwnProperty(fieldNumber)) {
                if (formStructure[fieldNumber].hasOwnProperty('field')) {
                    fieldIdList.push(formStructure[fieldNumber]['field']);
                }
            }
        }

        if (Utils.isEmptyArray(fieldIdList)) {
            return [];
        }
        // get detail list custom field by with id list
        const customFieldDetailList = await getFieldListInForm(
            API,
            corporationId,
            fieldIdList
        );

        return customFieldDetailList;
    }
};


// get form from list form of project
export const getFormFromFormListById =async (id) => {
    const formDetail = await getFormById(API,id)
    return formDetail;
};

export const handleClickViewTicketDetail = async (
    props,
    API,
    ticketId,
    ticketInfo,
    chatPostAllList,
    chatThreadId,
    userDetail,
    addNewPanel,
    selectedProject,
    isOpenChat = false
) => {
    let panelType = (props.panelType.includes("helpdesk")) 
        ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
        : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;
    
    if (props?.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER) {
        panelType = Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;
        if (props?.approveFlag && [Constant.APPROVE_FLAG.APPROVE, Constant.APPROVE_FLAG.REJECTED].includes(props?.approveFlag)) {
            panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
        }
    }
    props.panelType = panelType

    const isReadNotification = props?.isReadNotification || false;
    const timer1 = isReadNotification ? 0 : 3000;
    const timer2 = isReadNotification ? 1500 : 2000;
    let openDetailPanelProps = {
        API: props.API,
        ticketId: ticketId,
        panelType: props.panelType,
        history: props.history,
    }

    let newPanelId = Date.now().toString();
    setTimeout(async () => {
        await addNewPanel({
            type: panelType,
            tabId: ticketId,
            newPanelId: newPanelId,
            props: openDetailPanelProps,
            ticketId,
            ticketOutline: props?.ticketDetail?.outline,
            isOpenChat: isOpenChat,
            isDraft: props?.ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT,
            isTicketDeleted: !Utils.isEmptyString(props?.ticketDetail?.deletedAt),
            isEmailTicket: props?.ticketType === Constant.TICKET_TYPE.EMAIL,
        });

        if (isOpenChat) {
            let chatThreadPanelType = panelType === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
                ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;

            setTimeout(async () => {
                await addNewPanel({
                    type: chatThreadPanelType,
                    tabId: ticketId,
                    currentPanelId: newPanelId,
                    props: openDetailPanelProps,
                    ticketId,
                    ticketOutline: props?.ticketDetail?.outline,
                    selectThreadId: props?.sourceInfo?.chatThreadId,
                    isDraft: props?.ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT,
                    isTicketDeleted: !Utils.isEmptyString(props?.ticketDetail?.deletedAt),
                    openRelatePanelType: panelType
                });
            }, timer2)
        }
    }, timer1)
};

export const sortListByOrder = (listForm, projectId) => {
    let listResult = listForm.sort((formA, formB) => {
        let orderA = JSON.parse(formA.order) ? JSON.parse(formA.order)[projectId] : null;
        let orderB = JSON.parse(formB.order) ? JSON.parse(formB.order)[projectId] : null;

        return orderA - orderB;
    })

    return listResult;
}


export const viewTicketKnowledgeDetail = async (props, ticketId, addNewPanel, setLastUserAction,isViewByList = false) => {
    const { projectInuseDetail, userDetail, setIsLoading, setIsOpenModalReloadPage, setContentModalReloadPage, corporationDetail } = props;
    if(!Utils.isEmpty(props.setOpenShareStatusPopover)){
        props.setOpenShareStatusPopover(null);
    }
    if (!ticketId) {
        return;
    }
    showLoadingMouse('showProgress')
    let ticketDetail = await getTicketById(API, ticketId, null, false);

    hideLoadingMouse('showProgress')
    if (!ticketDetail || Utils.isEmptyObject(ticketDetail)) {
        if (setContentModalReloadPage && setIsOpenModalReloadPage) {
            if (setIsLoading) {
                setIsLoading(false);
            }
            setContentModalReloadPage(trI18n('MSG-CM-DELETED-TICKET'));
            setIsOpenModalReloadPage(true);
        }
        return;
    }

    if (ticketDetail.errorMessage && ticketDetail.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
        if (setIsOpenModalReloadPage) {
            if (setIsLoading) {
                setIsLoading(false);
            }
            setIsOpenModalReloadPage(true);
        }
        return;
    }

    if (userDetail?.id !== ticketDetail?.creator) {
        if (setIsLoading) {
            setIsLoading(true);
        }

        const isValid = checkViewPermissionKnowDetailInList(
            API,
            ticketDetail,
            projectInuseDetail,
            userDetail?.id,
            true
        );
        if (setIsLoading) {
            setIsLoading(false);
        }

        if (!isValid) {
            if (setIsOpenModalReloadPage) {
                setIsOpenModalReloadPage(true);
            }
            return;
        }
    } else {
        if (setIsLoading) {
            setIsLoading(false);
        }
    }

    if (corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK && [
        Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE,
        Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE
    ].includes(ticketDetail?.ticketType)) {
        if (setIsLoading) {
            setIsLoading(true);
        }

        const newCorporationInfo = await getCorporationById(API, props?.corporationDetail?.id);
        const inviterSetting = Utils.convertJSONDataToObject(newCorporationInfo.inviterSetting);

        if (setIsLoading) {
            setIsLoading(false);
        }

        if (!inviterSetting?.convertPDF) {
            if (setIsOpenModalReloadPage) {
                setIsOpenModalReloadPage(true);
            }
            return;
        }
    }
    
    let ticketOutline = '';
    if (!Utils.isEmptyObject(ticketDetail) && ticketDetail.settingTitle) {
        ticketOutline = Utils.getTitle(ticketDetail.settingTitle);
    }

    const openKnowledgeDetailPanelProps = {
        API: API,
        tabId: props.tabId,
        panelId: props.panelId,
        ticketId: ticketDetail.id,
        panelType: props.panelType,
        history: props.history,
    };

    if ([Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE, Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE].includes(ticketDetail.ticketType)) {
        let pdfKnowledgeAddNewPanel = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
            tabId: ticketDetail.id,
            currentPanelId: props.panelId,
            ticketId: ticketDetail.id,
            isCustomer: props.isCustomer,
            isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false,
            isViewByList: isViewByList,
            ticketOutline: ticketOutline,
            isPDFKnowledge: true
        }
        addNewPanel(pdfKnowledgeAddNewPanel);
        return;
    }

    let objAddNewPanel = {
        // type: props.isCustomer ? Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_DETAIL : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
        type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
        tabId: ticketId,
        openKnowledgeDetailPanelProps,
        ticketId,
        isCustomer: props.isCustomer,
        isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false,
        isViewByList: isViewByList,
        currentPanelId: props.panelId
    }

    if (ticketOutline) {
        objAddNewPanel.ticketOutline = JSON.stringify({ jp: ticketOutline });
    }
    objAddNewPanel.isDraft = ticketDetail.public === Constant.TICKET_PUBLIC.DRAFT;
    if (setLastUserAction) {
        setLastUserAction(LogKibanaConstant.CONTENT_OPERATION_ACTION.VIEW);
    }

    addNewPanel(objAddNewPanel);
}


export const getRichTextFieldContent = (html, isAIRichText = false) => { // add isAIRichText to fix issue #112519, set default false to don't effect to other
    let textInput = '';
    if (!html) return textInput;

    // init editorState
    const editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(html))
    );

    let blocks = convertToRaw(editorState.getCurrentContent()).blocks;
    
    // Remove all line break 
    if(!isAIRichText){ 
        blocks = blocks.filter(block =>  !['"', '\\n"', '\\n'].includes(block.text));
    }else{
        blocks = blocks.map((block, idx) => {
            let breakLineText = ""
            if(idx == 0 || idx == blocks.length - 1){ //don't set <br> for first and last line
                breakLineText = block.text.replace(/\\n|\n|"/g, "")
            }else{
                breakLineText = block.text.replace(/\\n|\n|"/g, "</br>")
            }
            return {...block, text: breakLineText.trim()}
        })
    }
   
    // Join text
    textInput = blocks.map(block => (!block.text.trim() && '\n') || block.text).join(' ');
    textInput = textInput?.trim();

    return textInput;
}

function getTextWidth(text, font) {
    // re-use canvas object for better performance
    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    let context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}

export const cutTextByWidth = (text, textFont, widthCut) => {
    let array = Array.from(text);

    let textRes = '';
    let sunWidth = 0;

    let index = 0;
    for (index = 0; index < array.length; index++) {
        const item = array[index];
        let widthItem = getTextWidth(item, textFont);

        sunWidth = sunWidth + widthItem;
        textRes = `${textRes}${item}`;

        if(sunWidth >= widthCut) {
            break;
        }
    }

    let res = {
        value: textRes,
        index: index
    };

    return res;
}

export const generateKnowledgeOutlineOnTabChat = (ticketInfo) => {
    let ticketOutline = '';
    
    if (!Utils.isEmptyObject(ticketInfo) && ticketInfo.outline) {
        ticketOutline = Utils.convertJSONDataToObject(ticketInfo.outline);
        if (typeof ticketOutline === 'object') {
            ticketOutline = ticketOutline.jp;
        }
    }

    return ticketOutline;
}

export const generateTicketOutlineOnTabChat = (ticketInfo) => {
    let ticketOutline = Constant.DEFAULT_TICKET_NO_TITLE;
    if (!ticketInfo || Utils.isEmptyObject(ticketInfo)) return ticketOutline;

    if (ticketInfo?.settingTitle){
        return generateDetatilTicketTitle(ticketInfo);
    }
    
    return ticketInfo?.outline
        ? Utils.convertJSONDataToObject(ticketInfo?.outline)?.jp
        : ticketOutline
}

export const generateDetatilTicketTitle = (ticket) => {
    let settingTitle = cloneDeep(ticket?.settingTitle);
    if (!settingTitle || Utils.isEmptyArray(settingTitle)) return '';
    let fullTitle = settingTitle.map(title => title.text).join(' ');
    if (ticket.ticketType === Constant.TICKET_TYPE.TELEPHONE) {

        fullTitle = settingTitle.map(t => Utils.formatIfDateTimeString(t.text)).join(' ');
    }
    return fullTitle;
};

export const generateTicketTitle = (ticket,numberLine=0,font) => {
    
    let maxRow = 2;
    if(numberLine === 0){
        maxRow = 10000
    }
    let textFont =font ? font : '500 16px Zen Kaku Gothic New';

    let titleElementSelector = document.querySelector(`.contentPanel`);
    let titleBoundingClient = titleElementSelector?.getBoundingClientRect();
    let maxWidthTitle = titleBoundingClient?.width;

    let titleResults = [];
    let currentRow = 0;
    let restValue = '';

    let settingTitle = cloneDeep(ticket.settingTitle);
    let fullTitle = Utils.getTitle(settingTitle)
    if (Utils.isEmptyArray(settingTitle)) return '';

    for (let i = 0; i < settingTitle.length; i++) {
        if (currentRow >= maxRow) break;

        let itemSetting = settingTitle[i];
        let currentRowValue = !Utils.isEmptyString(titleResults[currentRow])
            ? titleResults[currentRow]
            : '';
        let currentRowWidth = !Utils.isEmptyString(currentRowValue)
            ? getTextWidth(currentRowValue, textFont)
            : 0;

        if (itemSetting.isBreak) {
            if (currentRowValue === '') {
                // titleResults.push('');
            } else {
                titleResults[currentRow] = `${currentRowValue}\n`;
                currentRow++;
            }
            continue;
        }

        let textValue = itemSetting.text;
        
        if (Utils.isEmptyString(textValue)) {
            continue;
        }
        let textWidth = getTextWidth(textValue, textFont);

        let deviantWidth = Number(maxWidthTitle) - Number(currentRowWidth + textWidth);
        
        if (deviantWidth === 0) {
            currentRowValue = `${currentRowValue} ${textValue}\n`;
            titleResults[currentRow] = currentRowValue;

            currentRow++;
        } else if (deviantWidth > 0) {
            currentRowValue = `${currentRowValue}${textValue}`;
            titleResults[currentRow] = currentRowValue;
        } else {
            currentRowValue = `${currentRowValue}${textValue}`;

            let cutRes = cutTextByWidth(currentRowValue, textFont, maxWidthTitle);

            let cutTextVal = cutRes.value;
            titleResults[currentRow] = `${cutTextVal}\n`;
            currentRow++;
            if (currentRow >= maxRow) break;

            restValue = currentRowValue.slice(cutRes.index + 1, currentRowValue.length);

            let settingNext = cloneDeep(settingTitle[i + 1]);
            if (settingNext) {
                settingTitle[i + 1].text = `${restValue}${settingNext.text}`;
            }else{
                if(i+1 === settingTitle.length && currentRow < maxRow){
                    
                    let lastText = cutTextByWidth(restValue, textFont, maxWidthTitle)
                    titleResults[currentRow+1] = `${lastText.value}\n`
                }
            }
        }
    }
    
    let title = titleResults.join(' ');
    
    if(title?.trim()?.length < fullTitle?.trim().length){
        
        title = title.slice(0, -3);
        title = title + '...'
    }
    return title;
};

// sort list by order
export const sortKnowledgeTicketByOrder = (list, args) => {
    let projectId = args.projectInuseDetail.id;

    if (list.length > 1) {
        let listResult = list.sort((formA, formB) => {
            let orderA = JSON.parse(formA.order) ? JSON.parse(formA.order)[projectId] : null;
            let orderB = JSON.parse(formB.order) ? JSON.parse(formB.order)[projectId] : null;

            return orderA - orderB;
        })

        // Sort with 'system' items on top
        listResult = listResult.sort((a, b) => {
                if (
                    a?.definition === Constant.FORM_DEFINITION.SYSTEM &&
                    b?.definition === Constant.FORM_DEFINITION.USER
                ) {
                    return -1; // a comes before b
                }
                if (
                    a?.definition === Constant.FORM_DEFINITION.USER &&
                    b?.definition === Constant.FORM_DEFINITION.SYSTEM
                ) {
                    return 1; // b comes before a
                }
                return 0; // No change in order for items of the same type
        });

        return listResult;
    } else {
        return list;
    }
}

export const isTicketCountNumber = (type) => {
    return [
        Constant.TICKET_TYPE.QA,
        Constant.TICKET_TYPE.INTERNAL_QA,
        Constant.TICKET_TYPE.EXTERNAL_QA,
        Constant.TICKET_TYPE.DELEGATE,
        Constant.TICKET_TYPE.NOTICE,
        Constant.TICKET_TYPE.ESCALATION,
        Constant.TICKET_TYPE.BROADCAST_PARENT,
        Constant.TICKET_TYPE.TASK,
        Constant.TICKET_TYPE.EMAIL,
        Constant.TICKET_TYPE.TELEPHONE,
    ].includes(type);
}

export const updateLimitNumOfTicket = (args, action = 'add') => {
    let corporationDetail = cloneDeep(args.corporationDetail);
    let currentLimitValue = corporationDetail.limitValue;
    let numOfTicket = currentLimitValue ? currentLimitValue.numOfTicket : 0;
    let numOfTicketUpdate = action === 'add' ? numOfTicket + 1 : numOfTicket - 1;

    corporationDetail.limitValue.numOfTicket = numOfTicketUpdate;
    args.setCorporationDetail(corporationDetail);
}

export const isDisableApproveRejectAnonymousQaFromLiveChat = (
    ticket,
    projectInuseDetail,
    corporationDetail,
    isBtnChatNow
) => {

    let publicKnowledgeSiteSetting = Utils.convertJSONDataToObject(
        projectInuseDetail?.publicKnowledgeSiteSetting
    );
    let chatbotSetting = Utils.convertJSONDataToObject(projectInuseDetail?.chatbotSetting);

    if (
        !isBtnChatNow &&
        (ticket.anonymousQaStatus ===
            Constant.ANONYMOUS_TICKET_STATUS.END_LIVE_CHAT_AGENT_NOT_RESPONSE ||
            ticket.anonymousQaStatus ===
                Constant.ANONYMOUS_TICKET_STATUS.END_LIVE_CHAT_CASE_TICKET_WAITING)
    ) {
        return false;
    }

    if (!isAnonymousQAWaitingTicket(ticket)) return true;
    

    if (
        isBtnChatNow &&
        (!publicKnowledgeSiteSetting?.isShowChatbot ||
            !chatbotSetting?.isActivateChatbot ||
            corporationDetail?.publicService === Constant.STATUS_SERVICE_PERMISSION.OFF)
    ) {
        return true;
    }
    return false;
};

export const viewTicketKnowledgeDetailDuplicate = async (props, ticketId, addNewPanel, setLastUserAction,isViewByList = false, detailTicket) => {
    const { setIsLoading } = props;
    
    let ticketDetail = {...detailTicket};

    if (setIsLoading) {
        setIsLoading(false);
    }

    let ticketOutline = '';
    if (!Utils.isEmptyObject(ticketDetail) && ticketDetail.settingTitle) {
        ticketOutline = Utils.getTitle(ticketDetail.settingTitle);
    }

    const openKnowledgeDetailPanelProps = {
        API: API,
        tabId: props.tabId,
        panelId: props.panelId,
        ticketId: ticketDetail.id,
        panelType: props.panelType,
        history: props.history,
    };

    let objAddNewPanel = {
        type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
        openKnowledgeDetailPanelProps,
        ticketId: ticketDetail.id,
        isCustomer: props.isCustomer,
        isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false,
        isViewByList: isViewByList
    }

    if (ticketOutline) {
        objAddNewPanel.ticketOutline = JSON.stringify({ jp: ticketOutline });
    }
    
    objAddNewPanel.tabId = `${Constant.TAB_PANEL_TYPE.TAB_DUPLICATE_TICKET}${uuidv4()}`;
    
    objAddNewPanel.isDraft = true;
    objAddNewPanel.isDuplicate = true;

    addNewPanel(objAddNewPanel);
    return;
}

export const closePanelTabDetailTicket = (closePanelParams) => {
    if (!closePanelParams) return;
    const {
        isEdited, 
        setIsOpenPopupConfirm, 
        panelType, 
        panelId, 
        detailTicket, 
        panelList, 
        closePanelTab, 
        setCloseTabIdState,
        removePanelInitData,
        panelInitData,
        setPanelInitData
    } = closePanelParams;

    if (isEdited) {
        setIsOpenPopupConfirm(true);
    } else {
        let closeList = [];
        
        closeList.push({
            panelType: panelType,
            panelId: panelId,
            tabId: detailTicket.id
        })

        let panelChatThread;
        if (panelType === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL) {
            panelChatThread = panelList.find(panel => Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD === panel.type)

        } else if (panelType === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL) {
            panelChatThread = panelList.find(panel => Constant.PANEL_TYPE.HELPDESK_CHATTHREAD === panel.type)

        } else if (panelType === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL) {
            panelChatThread = panelList.find(panel => Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD === panel.type)
        }
        
        if (panelChatThread) {
            closeList.push({
                panelType: panelChatThread.type,
                panelId: panelChatThread.id,
                tabId: detailTicket.id
            })
        }
        
        closePanelTab({
            event: null,
            isCloseMulti: true,
            closeList: closeList
        });

        if (removePanelInitData && panelInitData && setPanelInitData) {
            removePanelInitData(panelId, detailTicket?.id, panelInitData, setPanelInitData);
        }
    }
    setCloseTabIdState(0);
}

const getInitialPanelType = (props) => {
    if (props?.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER) {
        if (
            [Constant.APPROVE_FLAG.APPROVE, Constant.APPROVE_FLAG.REJECTED].includes(props?.approveFlag)
        ) {
            return Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
        }
        return Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;
    }

    return props.panelType.includes(Constant.TYPE_GET_TICKET_LIST.HELPDESK)
        ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
        : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;
};

const isBroadcast = (ticketType) =>
    [Constant.TICKET_TYPE.BROADCAST_PARENT, Constant.TICKET_TYPE.BROADCAST_CHILD].includes(ticketType);

const handleCustomerPanelLogic = ({ ticketInfo, props, isEscalation, isBroadcastChild, panelType, ticketId }) => {
    let result = {
        ticketIdOpen: ticketId,
        panelType: panelType,
        ticketOutline: ticketInfo?.outline ?? props?.ticketDetail?.outline,
        isOpenPanelChat: false
    };

    if (isBroadcast(ticketInfo?.ticketType)) {
        result.isOpenPanelChat = true;
        result.ticketIdOpen = isBroadcastChild ? ticketInfo?.id : props?.ticketId;
        return result;
    }

    if (!isEscalation) {
        result.panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
        result.isOpenPanelChat = isDisplayIconChat({ detailTicket: { ...ticketInfo } });
        result.ticketOutline = ticketInfo?.outline ?? props?.ticketInfo?.outline;
        return result;
    }

    result.ticketIdOpen = props?.ticketId;
    result.isOpenPanelChat = isDisplayIconChat({ detailTicket: { ...ticketInfo } });
    return result;
};

export const handleViewTicketDetailByChat = async (props, ticketId, ticketInfo, addNewPanel) => {
    let panelType = getInitialPanelType(props);
    const isEscalation = ticketInfo?.ticketType === Constant.TICKET_TYPE.ESCALATION;
    const isBroadcastChild = ticketInfo?.ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD;
    const isCustomerPanel = panelType === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;
    const isHelpdeskPanel = panelType === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;

    let ticketIdOpen = ticketId;
    let ticketOutline = ticketInfo?.outline ?? props?.ticketDetail?.outline;
    let isOpenPanelChat = false;

    if (isCustomerPanel) {
        const customerPanelData = handleCustomerPanelLogic({ ticketInfo, props, isEscalation, isBroadcastChild, panelType, ticketId });
        panelType = customerPanelData.panelType;
        ticketIdOpen = customerPanelData.ticketIdOpen;
        ticketOutline = customerPanelData.ticketOutline;
        isOpenPanelChat = customerPanelData.isOpenPanelChat;
    }

    if (isHelpdeskPanel) {
        ticketOutline = ticketInfo?.outline ?? props?.ticketInfo?.outline;
        if (isEscalation) {
            panelType = ticketId === props?.ticketId
                ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;
            isOpenPanelChat = isDisplayIconChat({ detailTicket: { ...ticketInfo } });

            if (
                ![ticketInfo?.affiliationProject, ticketInfo?.projectOrigin].includes(
                    props?.projectInuseDetail?.id
                )
            ) {
                panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
                isOpenPanelChat = false;
            }
        }
    }

    props.panelType = panelType;

    const timer1 = 0;
    const timer2 = 1000;
    const openDetailPanelProps = {
        API: props.API,
        ticketId: ticketIdOpen,
        panelType: props.panelType,
        history: props.history
    };

    let newPanelId = Date.now().toString();
    const commonPanelProps = {
        ticketId: ticketIdOpen,
        ticketOutline: ticketOutline,
        isDraft: props?.ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT,
        isTicketDeleted: !Utils.isEmptyString(props?.ticketDetail?.deletedAt)
    };

    setTimeout(async () => {
        await addNewPanel({
            type: panelType,
            tabId: ticketIdOpen,
            newPanelId: newPanelId,
            props: openDetailPanelProps,
            ...commonPanelProps,
            isOpenChat: isOpenPanelChat,
            isEmailTicket: props?.ticketType === Constant.TICKET_TYPE.EMAIL
        });

        if (isOpenPanelChat) {
            let chatThreadPanelType = panelType === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
                ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;

            setTimeout(async () => {
                await addNewPanel({
                    type: chatThreadPanelType,
                    tabId: ticketIdOpen,
                    currentPanelId: newPanelId,
                    props: openDetailPanelProps,
                    ...commonPanelProps,
                    selectThreadId: props?.sourceInfo?.chatThreadId,
                    openRelatePanelType: panelType
                });
            }, timer2)
        }
    }, timer1)
};

/**
 * Check if form is QA request form
 * @param {Object} form - Form object
 * @param {string} formType - Form type to check (default is FORM_REQ_QA)
 * @returns {boolean} True if form is QA request form, false otherwise
 */
export const isFormByType = (form, formType = Constant.FORM_TYPE.FORM_REQ_QA) => {
    return form.type === formType && 
           !Utils.isSystemTelephoneForm(form);
};

/**
 * Filter QA request forms
 * @param {Array} formList - List of forms to filter
 * @param {string} formType - Form type to filter (default is FORM_REQ_QA)
 * @returns {Array} Filtered form list
 */
export const filterQaRequestForms = (formList, formType = Constant.FORM_TYPE.FORM_REQ_QA) => {
    return formList.filter(form => isFormByType(form, formType));
};

/**
 * Filter and sort forms of project
 * @param {Array} formList - List of forms to filter
 * @param {string} projectId - Project ID
 * @param {string} formType - Form type to filter (default is FORM_REQ_QA)
 * @returns {Array} Filtered and sorted form list
 */
export const getFilteredAndSortedForms = (formList, projectId, formType = Constant.FORM_TYPE.FORM_REQ_QA) => {
    // Filter forms by type and exclude system telephone forms
    let filteredForms = filterQaRequestForms(formList, formType);
    
    // Sort by order
    filteredForms = sortListByOrder(filteredForms, projectId);
    
    return filteredForms;
};

export const isDisableCallBackButton = (metaData, voiceStatus) => {
    let isDisable = false;

    if (!metaData) {
        return isDisable;
    }
    const metaDataObject = Utils.convertJSONDataToObject(metaData);

    const callDirection = metaDataObject?.callDirection;
    if (!callDirection) {
        return isDisable;
    }

    let phoneNumber = '';
    switch (callDirection) {
        case TelephoneConstant.CALL_DIRECTION.INBOUND:
            phoneNumber = metaDataObject?.from;
            break;
        case TelephoneConstant.CALL_DIRECTION.OUTBOUND:
            phoneNumber = metaDataObject?.to;
            break;
        default:
            break;
    }
    if (!phoneNumber || Utils.isEmptyString(phoneNumber)) {
        isDisable = true;
    }

    if (voiceStatus === Constant.PHONE_AVAILABILITY.ACTIVE || voiceStatus === Constant.PHONE_AVAILABILITY.DISCONNECTED) {
        isDisable = true;
    }

    return isDisable;
};

export const getTelephoneTicketIcon = (
    metaData,
    callDirectionParams,
    projectInuseDetail,
    userDetail
) => {
    if (metaData?.telephoneType === Constant.TICKET_PROPERTY.TRAINING) {
        return '/assets/image/icon-telephone-training.svg';
    }

    if (metaData?.telephoneType === TelephoneConstant.METADATA_TELEPHONE_TYPE.APP_INTEGRATION) {
        return '/assets/image/icon-telephone-app-integration.svg';
    }

    let callDirection = callDirectionParams;

    if (metaData?.callType === TelephoneConstant.CALL_TYPE.VOICE_CALL) {
        if (
            metaData?.callerId &&
            Utils.getPrefixOfId(metaData?.callerId) === Constant.ID_PREFIX.PROJECT
        ) {
            callDirection =
                projectInuseDetail?.id === metaData?.callerId
                    ? TelephoneConstant.CALL_DIRECTION.OUTBOUND
                    : TelephoneConstant.CALL_DIRECTION.INBOUND;
        }

        if (
            metaData?.callerId &&
            Utils.getPrefixOfId(metaData?.callerId) === Constant.ID_PREFIX.USER
        ) {
            callDirection =
                userDetail?.id === metaData?.callerId &&
                projectInuseDetail?.type === Constant.PROJECT_TYPE.BASE
                    ? TelephoneConstant.CALL_DIRECTION.OUTBOUND
                    : TelephoneConstant.CALL_DIRECTION.INBOUND;
        }
    }
    return callDirection === TelephoneConstant.CALL_DIRECTION.OUTBOUND
        ? '/assets/image/icon-telephone-outgoing.svg'
        : '/assets/image/icon-telephone-incoming.svg';
};